
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import { Lead, ProjectInfo, LeadStatus as LeadStatusType } from '@/types';

const statusDetails = {
  draft: {
    long: 'Bozza',
    color: 'blue-grey',
    dark: true,
  },
  new: {
    long: 'Nuova',
    color: 'blue',
    dark: true,
  },
  open: {
    long: 'In Lavorazione',
    color: 'orange',
    dark: true,
  },
  pending: {
    long: 'In Attesa',
    color: 'amber',
    dark: true,
  },
  resolved: {
    long: 'Completata',
    color: 'green',
    dark: true,
  },
  closed: {
    long: 'Chiusa',
    color: 'grey',
    dark: true,
  },
  rejected: {
    long: 'Respinta',
    color: 'red',
    dark: true,
  },
  cancelled: {
    long: 'Annullata',
    color: 'grey',
    dark: true,
  },
} as {
  [key: string]: {
    long: string;
    color: string;
    dark: boolean;
  };
};

@Component
export default class LeadStatus extends Vue {
  @Prop(Object) readonly childLeadInfo: ProjectInfo | Lead | undefined;

  get lead(): ProjectInfo | Lead {
    return this.childLeadInfo === undefined
      ? this.$store.getters.currentLead
      : this.childLeadInfo;
  }

  get status(): LeadStatusType | null {
    return this.lead ? this.lead.status : null;
  }

  get long() {
    return this.status && this.status in statusDetails ? statusDetails[this.status].long : null;
  }

  get color() {
    return this.status && this.status in statusDetails ? statusDetails[this.status].color : null;
  }

  get dark() {
    return this.status && this.status in statusDetails ? statusDetails[this.status].dark : null;
  }
}
